import { memo, useMemo } from "react";
import { rgbToCss } from "utils/rgbToCss";
import { ROUTE_STROKE_WIDTH } from "../CircuitPathsLayer/constants";
import { getCircleSize } from "../utils";
import { CREATION_RGB, NODE_RADIUS_FACTOR } from "./constants";
import { nodesEdgesToSvgPath } from "./helpers/nodesEdgesToSvgPath";
import type { FinalizedRouteRenderProps } from "./types";

export const FinalizedRouteRender = memo(function FinalizedRouteRender({
  route,
  zoomLevel,
  circleSizeScale,
}: FinalizedRouteRenderProps) {
  const pathD = useMemo(
    () => nodesEdgesToSvgPath({ nodes: route.nodes, edges: route.edges }),
    [route.nodes, route.edges],
  );

  if (!pathD) return null;

  const color = rgbToCss(CREATION_RGB);
  const size = getCircleSize(zoomLevel) * circleSizeScale;
  const nodeRadius = (size / 2) * NODE_RADIUS_FACTOR;

  return (
    <g opacity={0.55}>
      <path
        d={pathD}
        stroke={color}
        strokeWidth={ROUTE_STROKE_WIDTH}
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke"
      />
      {route.nodes.map((node) => (
        <circle
          key={`node-${node.id}`}
          cx={node.x}
          cy={node.y}
          r={nodeRadius}
          fill="none"
          stroke={color}
          strokeWidth={1.5}
          vectorEffect="non-scaling-stroke"
          pointerEvents="none"
        />
      ))}
    </g>
  );
});
